import { render, staticRenderFns } from "./vod.vue?vue&type=template&id=dc4c4d78&"
import script from "./vod.vue?vue&type=script&lang=js&"
export * from "./vod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports